// extracted by mini-css-extract-plugin
export default {"card":"VerifyEmail_card__Rr3DA","content":"VerifyEmail_content__GLix7","title":"VerifyEmail_title__oOPKJ","message":"VerifyEmail_message__b2nXq","action":"VerifyEmail_action__NMfMk"};